module.exports = __webpack_public_path__ + "img/ico_biaoqianzhanwen.d8720b2e.png";